import { Box, BoxProps } from "@mui/material";

const IssueClosedAnimation = (props: BoxProps) => {
  return (
    <Box
      component="object"
      type="image/svg+xml"
      data="/svg/issue-closed.svg"
      {...props}
      sx={{
        width: 100,
        ...props.sx,
      }}
    >
      Issue Closed Animation
    </Box>
  );
};

export { IssueClosedAnimation };
